export default "__VITE_ASSET__ButvUTeN__"